export default "__VITE_PUBLIC_ASSET__ee02b74d__"